<template>
  <div class="app-container">
    <el-form :inline="true" ref="form" label-width="180px" style="width: 100%;min-height: 500px;">
      <div v-for="(item, index) in regionalTypeArr" :key="index" style="margin-bottom:20px">
        <el-card shadow="hover" style="border:1px solid #1682e661">
          <!--              账户类型-->
          <div
            slot="header"
            class="clearfix"
            :style="{
              'background-color': '#1682e661'
            }"
          >
            <span style=" line-height: 28px;">{{ item.lable }}</span>
            <div style="float: right">
              <el-button
                type="primary"
                v-if="!item.isEdit"
                @click="checkEditStatus(index, true)"
                size="mini"
                >编辑</el-button
              >
              <el-button
                type="success"
                v-else
                @click="saveOk(item, index)"
                style="float: right;"
                size="mini"
                >保存</el-button
              >
            </div>
          </div>
          <el-row :gutter="10">
            <template v-if="item.rewardRule.length !== 0">
              <div class="drawer-item-edit" v-if="!item.isEdit">
                <span>{{ allData[index].state ? "启用" : "停用" }} </span>

                <el-switch
                  :value="!!allData[index].state"
                  class="drawer-switch"
                  @change="status => switchChange(status, item, index)"
                />
              </div>
              <div v-for="(trItem, trIndex) in item.rewardRule" :key="trIndex">
                <el-col :xs="24" :sm="6" :xl="6">
                  <el-form-item label="账户类别">
                    <span v-show="!item.isEdit">{{
                      getValue(categoryOption, trItem.category)
                    }}</span>
                    <el-select
                      v-model="trItem.category"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-show="item.isEdit"
                      v-el-select-loadmore="loadMore(rangeNumber)"
                    >
                      <el-option
                        v-for="o in categoryOption.slice(0, rangeNumber)"
                        :key="o.key"
                        :label="o.value"
                        :value="o.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :xl="6">
                  <el-form-item label="账户类型">
                    <span v-show="!item.isEdit">{{ getValue(ACCOUNT_TYPE, trItem.type) }}</span>
                    <el-select
                      v-model="trItem.type"
                      placeholder="请选择"
                      class="filter-item"
                      clearable
                      size="small"
                      v-show="item.isEdit"
                      v-el-select-loadmore="loadMore(rangeNumber)"
                    >
                      <el-option
                        v-for="o in ACCOUNT_TYPE.slice(0, rangeNumber)"
                        :key="o.key"
                        :label="o.value"
                        :value="o.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :xl="8">
                  <el-form-item label="赠送每单消费金额的百分比">
                    <span v-show="!item.isEdit">{{ trItem.rate }}</span>
                    <el-input
                      v-model="trItem.rate"
                      placeholder="请输入"
                      size="small"
                      v-show="item.isEdit"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="4" :xl="4" style="text-align: right">
                  <el-button
                    type="danger"
                    plain
                    size="medium"
                    @click="deleteHZ(index, trIndex)"
                    v-if="item.isEdit"
                    style="width: calc(100% - 150px)"
                    >删除</el-button
                  >
                </el-col>
                <el-col :xs="24" :sm="24" :xl="24">
                  <div class="fg_comm"></div>
                </el-col>
              </div>
            </template>
            <el-col :xs="24" :sm="24" :xl="24" style="text-align: right">
              <el-button
                type="success"
                plain
                style="width: calc(100% - 150px)"
                size="medium"
                @click="addTr(index)"
                v-if="item.isEdit"
                >添加</el-button
              >
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-form>
  </div>
</template>

<script>
import { ACCOUNT_TYPE, getValue } from "@/utils/enumUtile";
import {
  editRegionalAgent,
  getCategoryNames,
  getRegionalAgentDetail,
  getRegionalAgentSwitch
} from "@/api/system";
import { toFixedNumFun } from "@/utils";

export default {
  name: "index",
  computed: {
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    },
    getValue() {
      return getValue;
    }
  },
  data() {
    return {
      regionalTypeArr: [
        {
          type: 1,
          lable: "省代理",
          rewardRule: [],
          isEdit: false
        },
        {
          type: 2,
          lable: "市代理",
          rewardRule: [],
          isEdit: false
        },
        {
          type: 3,
          lable: "县/区代理",
          rewardRule: [],
          isEdit: false
        },
        {
          type: 4,
          lable: "乡镇代理",
          rewardRule: [],
          isEdit: false
        }
      ], // 代理类型
      categoryOption: [], // 类别选项
      rangeNumber: 10,
      allData: {}
    };
  },
  created() {
    this.getList();
    this.getCategory();
  },
  watch: {},
  methods: {
    async switchChange(status, item, index) {
      const params = {
        id: (this.allData[item.type - 1] || {}).id,
        state: status ? 1 : 0
      };
      console.log("----", status, item, this.allData[item.type - 1], params);
      const resp = await getRegionalAgentSwitch(params);

      if (resp && resp.bizcode === 100) {
        this.allData[index].state = status ? 1 : 0;
        this.$forceUpdate();

        this.$notify({
          message: "操作成功",
          type: "success",
          duration: 2000
        });
      }
    },
    loadMore(n) {
      // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数  可自定义
    },
    async getList() {
      const regionalTypeArr = this.regionalTypeArr;
      for (let i = 0; i < regionalTypeArr.length; i++) {
        const params = {
          type: regionalTypeArr[i].type
        };
        const resp = await getRegionalAgentDetail(params);
        if (resp && resp.bizcode === 100) {
          const data = resp.data;
          let rewardRule = [];
          if (data.rewardRule) {
            rewardRule = this.processingParameter(JSON.parse(data.rewardRule), "info");
          }
          this.allData[i] = data;
          regionalTypeArr[i].rewardRule = rewardRule;
        }
      }
    },
    getCategory() {
      getCategoryNames().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.categoryOption = resp.data;
        }
      });
    },
    checkEditStatus(index, status) {
      this.regionalTypeArr[index].isEdit = status;
    },
    /**
     * 添加账户相互转换的item
     * @param index
     */
    addTr(index) {
      const data = this.regionalTypeArr[index].rewardRule;
      data.push({
        category: null,
        type: null,
        rate: null
      });
      this.regionalTypeArr[index].rewardRule = data;
    },
    // 删除账户互转
    deleteHZ(index, trIndex) {
      this.regionalTypeArr[index].rewardRule.splice(trIndex, 1);
    },
    /**
     * 处理数据
     */
    processingParameter(paramList, type) {
      if (!paramList || paramList.lemgth === 0) {
        return [];
      }
      const newParamList = paramList;
      for (let i = 0; i < newParamList.length; i++) {
        const item = newParamList[i];
        // 提现手续比例
        const rate = item.rate;
        if (rate) {
          item.rate = toFixedNumFun(rate, type);
        }
        newParamList[i] = item;
      }
      return newParamList;
    },
    /**
     * 确认添加还是编辑
     */
    async saveOk(item, index) {
      const loading = this.$loading({
        lock: true,
        text: "保存中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const currentItem = item;

      const dataParams = {
        type: currentItem.type,
        rewardRule: JSON.stringify(this.processingParameter(currentItem.rewardRule, "save"))
      };
      const res = await editRegionalAgent(dataParams);
      loading.close();
      if (res && res.bizcode === 100) {
        this.getList();
        this.checkEditStatus(index, false);
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
          duration: 2000
        });
      }
    }
  },
  directives: {
    "el-select-loadmore": (el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) binding.value();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fg_comm {
  width: 100%;
  margin: 10px 0 20px;
  border: 1px dashed #eeeeee;
}
::v-deep .el-card__header {
  padding: 0px;
}
.clearfix {
  padding: 14px 20px;
}
.drawer-item-edit {
  width: 100%;
  text-align: end;
  font-size: 14px;
  margin-bottom: 10px;
}
</style>
